import { logger } from '../utils/logger';

const REGEX_LANG = new RegExp('[a-z]{2}');
const REGEX_MARKET = new RegExp('[A-Z]{2,15}');
const JAVA_LOCALE_DELIM = '_';

/**
 * Check if language code have the correct struct.
 * @param lang string
 * @returns boolean
 */
const checkLang = (lang: string) => {
  if (!REGEX_LANG.test(lang)) {
    throw new Error('Language is invalid!');
  }
  return true;
};

/**
 * Check if market code have the correct struct.
 * @param market string
 * @returns boolean
 */
const checkMarket = (market: string) => {
  if (!REGEX_MARKET.test(market)) {
    throw new Error('Market is invalid!');
  }
  return true;
};

/**
 * Split location in two "lang" and "market".
 * @param code string
 * @returns {lang, market}
 */
export const splitLocation = (code: string): { lang: string; market: string } => {
  try {
    const codeStore = code.split(JAVA_LOCALE_DELIM);
    if (checkLang(codeStore[0]) && checkMarket(codeStore[1])) {
      return {
        lang: codeStore[0],
        market: codeStore[1],
      };
    }
  } catch (err) {
    logger.info(err);
  }

  return {
    lang: '',
    market: '',
  };
};

/**
 * Merge code of lang with market.
 * @param lang string
 * @param market string
 * @returns "lang_string"
 */
export const mergeLocation = (lang: string, market: string): string | null => {
  try {
    if (checkLang(lang) && checkMarket(market)) {
      return `${lang}_${market}`;
    }
  } catch (err) {
    logger.info(err);
  }
  return null;
};
